const calculateResults = (
	index: number,
	formData: { [key: string]: number },
	calculatorKey: string
) => {
	if ('roi' === calculatorKey) {
		formData.C30 =
			(formData.C10 / formData.C11) * formData.C12 * (formData.C7 / 100) +
			formData.C14 * (formData.C7 / 100) +
			formData.C26 * (formData.C7 / 100);
		formData.C31 =
			((formData.C10 / formData.C11) * formData.C12 * (formData.C7 / 100) +
				formData.C14 * (formData.C7 / 100) +
				formData.C26 * (formData.C7 / 100)) *
			formData.C5;
		formData.C32 =
			((formData.C10 / formData.C11) * formData.C12 * (formData.C7 / 100) +
				formData.C14 * (formData.C7 / 100) +
				formData.C26 * (formData.C7 / 100)) *
			formData.C5 *
			formData.C6 *
			52;
		formData.C34 = formData.C19 * formData.C20 * (formData.C21 / 100) * formData.C5;
		formData.C35 =
			formData.C19 * formData.C20 * (formData.C21 / 100) * formData.C5 * formData.C6 * 52;
		formData.C37 = formData.C24 * formData.C5 * formData.C6 * 52;
		formData.C38 = formData.C25 * formData.C5 * formData.C6 * 52;
		formData.C40 =
			((formData.C10 / formData.C11) * formData.C12 * (formData.C7 / 100) +
				formData.C14 * (formData.C7 / 100) +
				formData.C26 * (formData.C7 / 100)) *
				formData.C5 *
				formData.C6 *
				52 +
			formData.C19 * formData.C20 * (formData.C21 / 100) * formData.C5 * formData.C6 * 52 +
			formData.C24 * formData.C5 * formData.C6 * 52 +
			formData.C25 * formData.C5 * formData.C6 * 52;
		switch (index) {
			case -1:
				return formData;
			case 0:
				return formData.C30;
			case 1:
				return formData.C31;
			case 2:
				return formData.C32;
			case 3:
				return formData.C34;
			case 4:
				return formData.C35;
			case 5:
				return formData.C37;
			case 6:
				return formData.C38;
			case 7:
				return formData.C40;
			default:
				return 0;
		}
	}
	if ('pld' === calculatorKey) {
		formData.C33 =
			(formData.C10 / formData.C11) * formData.C12 * (formData.C7 / 100) +
			formData.C14 * (formData.C7 / 100) * (formData.C7 / 100);
		formData.C34 = formData.C33 * formData.C5;
		formData.C35 = formData.C33 * formData.C5 * formData.C6 * 52;
		formData.C37 =
			formData.C18 * 8 * (formData.C7 / 100) +
			formData.C18 * 0.5 +
			formData.C19 * formData.C20 * (formData.C21 / 100);
		formData.C38 = formData.C37 * formData.C5;
		formData.C39 = formData.C38 * formData.C6 * 52;
		formData.C41 = formData.C19 * formData.C20 * (formData.C21 / 100) * formData.C5;
		formData.C42 =
			formData.C19 * formData.C20 * (formData.C21 / 100) * formData.C5 * formData.C6 * 52;
		formData.C44 = formData.C26 * formData.C5 * formData.C6 * 52;
		formData.C45 = formData.C27 * formData.C5 * formData.C6 * 52;
		formData.C47 = formData.C35 + formData.C39 + formData.C42 + formData.C44 + formData.C45;
		switch (index) {
			case -1:
				return formData;
			case 0:
				return formData.C33;
			case 1:
				return formData.C34;
			case 2:
				return formData.C35;
			case 3:
				return formData.C37;
			case 4:
				return formData.C38;
			case 5:
				return formData.C39;
			case 6:
				return formData.C41;
			case 7:
				return formData.C42;
			case 8:
				return formData.C44;
			case 9:
				return formData.C45;
			case 10:
				return formData.C47;
			default:
				return 0;
		}
	}
	return 0;
};

export default calculateResults;
